/* eslint-disable no-console */
import { useContext, useState, useEffect } from 'react';
import { AppShell, Box } from '@mantine/core';
import TopNav from './Header';
import AppContext from './Context';

function launchFullScreen() {
  const element = document.documentElement;
  if (element.requestFullscreen) {
    element.requestFullscreen().catch((err) => {
      console.log(err.message);
    });
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen().catch((err) => {
      console.log(err.message);
    });
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen().catch((err) => {
      console.log(err.message);
    });
  }
}

const MyApp = ({ children, paymentStatus, ticketId, totalSeconds }) => {
  const [opened, setOpened] = useState(false);
  const appContextState = useContext(AppContext);
  const { appState } = appContextState;

  const menuList = [
    { label: 'Home', path: '/home', id: '1' },
    { label: 'Refund', path: '/refund', id: '2' },
    { label: 'History', path: '/history', id: '3' },
  ];

  useEffect(() => {
    function disableRightClick(event) {
      event.preventDefault();
    }
    document.addEventListener('contextmenu', disableRightClick);
    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
    };
  }, []);

  useEffect(() => {
    const launchOnUserGesture = () => {
      launchFullScreen();
    };
    document.addEventListener('click', launchOnUserGesture);
    return () => {
      document.removeEventListener('click', launchOnUserGesture);
    };
  }, []);

  return (
    <AppShell
      styles={(theme) => ({
        root: {
          minHeight: '100vh',
        },
        main: {
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : 'white',
          color: theme.colorScheme === 'dark' ? theme.colors.gray[1] : theme.colors.gray[8],
          padding: 0,
          overflowX: 'hidden',
          minHeight: 'calc(100vh - 292px)',
        },
      })}
      header={
        <TopNav
          className="no-printme"
          opened={opened}
          setOpened={setOpened}
          hidden={opened}
          appState={appState}
          menuList={menuList}
          paymentStatus={paymentStatus}
          ticketId={ticketId}
          totalSeconds={totalSeconds}
        />
      }
    >
      <Box p="xl">{children}</Box>
    </AppShell>
  );
};

export default MyApp;
